import camelCase from 'lodash.camelcase';
import Vue from 'vue';

const requireModule = require.context('./', false, /\.\/(?!index)([\w\-\.]+)(\.ts)$/);

requireModule
  .keys()
  .forEach(importFilterFromFileByFileName);

function importFilterFromFileByFileName(fileName: string) {
  const filterName = prepareFileNameForImport(fileName);
  const module = requireModule(fileName);

  Vue.filter(filterName, module.default || module);
}

function prepareFileNameForImport(fileName: string) {
  return camelCase(
    fileName.replace(/(\.\/|\.ts)/g, '')
  );
}
